import styled from "styled-components";
import { theme, MEDIA_QUERIES } from "@ifgengineering/component-library";

export const EisFundPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-color: ${theme.colors.SLATE200};
`;

export const EisFundHeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: ${theme.colors.SLATE900};
  align-items: center;
`;

export const EisFundHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  padding: 24px 0;
  background-color: ${theme.colors.SLATE900};
  max-width: 1200px;

  @media ${MEDIA_QUERIES.TAB_PORT} {
    padding: 24px;
  }
`;

export const EisFundHeaderContent = styled.div`
  display: flex;
  flex-direction: row;
  gap: 32px;
  align-items: center;
`;

export const EisFundHeaderTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const BackButton = styled.button`
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;
  padding: 12px;
  background-color: ${theme.colors.SLATE800};
  border-radius: 50%;
  height: fit-content;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${theme.colors.SLATE700};
  }
`;

export const EisFundContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: ${theme.colors.SLATE200};
  align-items: center;
  flex-grow: 1;
  overflow-y: auto;
`;

export const EisFundContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  padding: 56px 0px;
  padding-left: 86px;
  background-color: ${theme.colors.SLATE200};
  max-width: 1200px;

  @media ${MEDIA_QUERIES.TAB_PORT} {
    padding: 24px;
  }
`;

export const QuickActionsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${theme.colors.WHITE};
  padding: 16px 24px;
  border-radius: 12px;
  box-shadow: 0 1px 6px rgba(52, 111, 180, 0.1);

  @media ${MEDIA_QUERIES.TAB_PORT} {
    flex-direction: column;
    gap: 16px;
    align-items: flex-start;
  }
`;

export const QuickActionsButtonGroup = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
`;

export const QuickActionButton = styled.button<{ $isActive?: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background-color: ${({ $isActive }) =>
    $isActive ? theme.colors.BLUE100 : theme.colors.WHITE};
  border: 1px solid
    ${({ $isActive }) =>
      $isActive ? theme.colors.BLUE600 : theme.colors.SLATE300};
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: ${theme.colors.SLATE800};
  transition: all 0.2s ease;

  &:hover {
    background-color: ${({ $isActive }) =>
      $isActive ? theme.colors.BLUE200 : theme.colors.SLATE100};
    border-color: ${({ $isActive }) =>
      $isActive ? theme.colors.BLUE700 : theme.colors.SLATE400};
  }

  &:active {
    background-color: ${({ $isActive }) =>
      $isActive ? theme.colors.BLUE200 : theme.colors.SLATE200};
  }
`;

export const SearchContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const SearchInput = styled.input`
  width: 100%;
  padding: 14px 16px;
  padding-right: 48px;
  background-color: ${theme.colors.WHITE};
  border: 1px solid ${theme.colors.SLATE300};
  border-radius: 8px;
  font-size: 16px;
  color: ${theme.colors.SLATE800};
  outline: none;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &::placeholder {
    color: ${theme.colors.SLATE500};
  }

  &:focus {
    border-color: ${theme.colors.BLUE600};
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
  }
`;

export const SearchIconWrapper = styled.div`
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
`;

export const AccountTabsContainer = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
`;

export const AccountTab = styled.button<{ $isActive: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background-color: ${({ $isActive }) =>
    $isActive ? theme.colors.SLATE900 : theme.colors.WHITE};
  color: ${({ $isActive }) =>
    $isActive ? theme.colors.WHITE : theme.colors.SLATE700};
  border: 1px solid
    ${({ $isActive }) =>
      $isActive ? theme.colors.SLATE900 : theme.colors.SLATE300};
  border-radius: 24px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${({ $isActive }) =>
      $isActive ? theme.colors.SLATE800 : theme.colors.SLATE100};
  }
`;

export const StartupCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${theme.colors.WHITE};
  border-radius: 16px;
  padding: 20px 24px;
  box-shadow: 0 1px 6px rgba(52, 111, 180, 0.1);
  transition: box-shadow 0.3s ease;

  &:hover {
    box-shadow: 0 4px 12px rgba(52, 111, 180, 0.15);
  }
`;

export const StartupCardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
`;

export const StartupCardLeft = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: ${theme.colors.SLATE100};
  padding: 8px;
  border-radius: 8px;
  cursor: pointer;
`;

export const StartupLogo = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: contain;
  background-color: ${theme.colors.SLATE100};
`;

export const StartupCardDetails = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
`;

export const DetailGroup = styled.div`
  display: flex;
  gap: 32px;
`;

export const DetailItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const StatusBadge = styled.span<{
  $backgroundColor: string;
  $textColor: string;
}>`
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  color: ${({ $textColor }) => $textColor};
`;

export const StartupsListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const FilterModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 8px;
  min-width: 400px;

  @media ${MEDIA_QUERIES.TAB_PORT} {
    min-width: 100%;
  }
`;

export const FilterSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const FilterButtonGroup = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 16px;
`;

export const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 64px 24px;
  min-height: 400px;
  text-align: center;
`;

export const ErrorBackButton = styled.button`
  margin-top: 16px;
  padding: 12px 24px;
  background-color: ${theme.colors.BLUE600};
  color: ${theme.colors.WHITE};
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${theme.colors.BLUE700};
  }
`;
